import React, { useState } from 'react';

// Componentes
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';

const positionMap = { left: 'flex-start', center: 'center', right: 'flex-end' };

export default function LinkButtonDisplay({ attributes }) {
  const { btnText, fontColor, btnColor, btnPosition, linkUrl, linkAction } = attributes;

  // State de modal
  const [modalOpen, setModalOpen] = useState(false);

  // Abre a URL em nova aba ou exibe o modal conforme a ação configurada
  const handleClick = () => {
    if (linkAction === 'modal') {
      setModalOpen(true);
    } else {
      window.open(linkUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <>
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: positionMap[btnPosition] || 'center',
        }}
      >
        <Button style={{ backgroundColor: btnColor }} onClick={handleClick}>
          <span style={{ color: fontColor }}>{btnText}</span>
        </Button>
      </div>

      {linkAction === 'modal' && (
        <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)} size="lg">
          <ModalHeader toggle={() => setModalOpen(false)}>{btnText}</ModalHeader>
          <ModalBody style={{ padding: 0 }}>
            <iframe
              src={linkUrl}
              title={btnText}
              style={{ width: '100%', height: '500px', border: 'none' }}
            />
          </ModalBody>
        </Modal>
      )}
    </>
  );
}
